import MusicShelfCarouselList from "./Carousel/MusicShelfCarousel";

function MusicShelfCarousel({...props}) {
  return <MusicShelfCarouselList {...props} />;
}

export default MusicShelfCarousel;

